import { TextBadge } from "@bcc-ui/ui-components";
import classNames from "classnames";
import React from "react";

import style from "./api-method-badge.scss";

interface Props {
    text: string;
    testId: string;
    type: Variant;
}

type Variant = "POST" | "GET" | "DELETE";

export const ApiMethodBadge = (props: Props) => {
    const badgeStyle = classNames(style.methodBadgeBase, {
        [style.getBadge]: props.type === "GET",
        [style.postBadge]: props.type === "POST",
        [style.deleteBadge]: props.type === "DELETE",
    });
    return <TextBadge text={props.text} className={badgeStyle} testId={props.testId} dataType={props.type} />;
};
